import { ReactNode } from 'react';
import { QueryKey } from 'react-query';

export interface QueryChanelContextProps {
  postQuery: (queryKeys: QueryChanelData, options?: QueryChanelOptions) => void;
}

export interface QueryChanelProviderProps {
  children: ReactNode;
}

export enum QueryChanelKey {
  invalidateQueries = 'invalidateQueries',
  removeQueries = 'removeQueries',
  refetchQueries = 'refetchQueries',
  resetQueries = 'resetQueries',
  cancelQueries = 'cancelQueries',
}

export type QueryChanelData = Partial<Record<QueryChanelKey, QueryKey[]>>;

export interface QueryChanelOptions {
  executeQueriesOnPost?: boolean;
}
